const BufonIcon = ({ width, height }) => {
    const defaultWidth = 17;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? defaultWidth}
            height={height ?? defaultWidth}
            viewBox="0 0 32 32"
        >
            <g fill="none">
                <path
                    fill="#F7A7B8"
                    d="M15.999 1C11.095 1 7.313 2.654 4.763 5.423C2.226 8.178 1 11.938 1 15.999c0 4.061 1.226 7.82 3.763 10.576c2.55 2.769 6.332 4.423 11.236 4.423c4.904 0 8.686-1.654 11.235-4.423c2.537-2.755 3.764-6.515 3.764-10.576c0-4.061-1.227-7.821-3.764-10.576C24.684 2.654 20.903 1 16 1Z"
                />
                <path
                    fill="#F8312F"
                    d="M11 7a3 3 0 1 0-2.14-5.102A5 5 0 0 0 1.898 8.86a3 3 0 1 0 5.1 2.04A5.006 5.006 0 0 0 10.9 6.998L11 7Zm10 0a3 3 0 1 1 2.14-5.102a5 5 0 0 1 6.962 6.962a3 3 0 1 1-5.1 2.04A5.006 5.006 0 0 1 21.1 6.998A3.028 3.028 0 0 1 21 7Z"
                />
                <path
                    fill="#fff"
                    d="M15.999 29.998c9.334 0 13.999-6.268 13.999-14c0-7.73-4.665-13.998-14-13.998C6.665 2 2 8.268 2 15.999c0 7.731 4.664 13.999 13.999 13.999Z"
                />
                <path
                    fill="#F70A8D"
                    d="M24.262 17.86c.449.201.738.648.738 1.14c0 2.498-1.048 4.538-2.741 5.93C20.589 26.303 18.356 27 16 27c-2.356 0-4.59-.697-6.259-2.07C8.048 23.538 7 21.498 7 19a1.25 1.25 0 0 1 1.972-1.02l.01.006l.066.044a6 6 0 0 0 .317.186c.291.16.74.383 1.338.608c1.193.45 2.98.913 5.296.913c2.612-.004 4.393-.473 5.488-.909a7.14 7.14 0 0 0 1.164-.576a3.45 3.45 0 0 0 .239-.164l.04-.031a1.25 1.25 0 0 1 1.332-.197Zm-2.254 3.443c-1.386.496-3.356.93-6.006.934H16c-2.576 0-4.617-.5-6.05-1.025A4.908 4.908 0 0 0 11.329 23c1.146.942 2.787 1.5 4.671 1.5c1.884 0 3.525-.558 4.671-1.5a4.919 4.919 0 0 0 1.337-1.697Z"
                />
                <path fill="#F8312F" d="M16 18a1.75 1.75 0 1 0 0-3.5a1.75 1.75 0 0 0 0 3.5Z" />
                <path
                    fill="#0074BA"
                    d="M15 12a5 5 0 1 1-10 0a5 5 0 0 1 10 0Zm12 0a5 5 0 1 1-10 0a5 5 0 0 1 10 0Z"
                />
                <path
                    fill="#fff"
                    d="M15 12.25a3.75 3.75 0 1 1-7.5 0a3.75 3.75 0 0 1 7.5 0Zm9.5 0a3.75 3.75 0 1 1-7.5 0a3.75 3.75 0 0 1 7.5 0Z"
                />
                <path
                    fill="#402A32"
                    d="M14.5 12.25a2.25 2.25 0 1 1-4.5 0a2.25 2.25 0 0 1 4.5 0Zm7.5 0a2.25 2.25 0 1 1-4.5 0a2.25 2.25 0 0 1 4.5 0Z"
                />
            </g>
        </svg>
    );
};

export default BufonIcon;
